import React from 'react'
import { Select, MenuItem, TextField, Checkbox, FormControl, FormControlLabel, FormGroup, Radio, RadioGroup } from '@mui/material';
import FormField from '../../Components/common-components/form-input';
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';


const ViewForm = ({ methods, data }) => {
    const { viewFieldsArry, fields } = data
    const {
        handleDateChange,
        handleRadioChange,
        handleCheckboxChange,
        handleInputChange,
        handleTextChange,
        handleSubmit,
        setViewFormModal
    } = methods

    return (
        <div className='row p-lg-4 p-md-4 p-2 overflow_Scroll' style={{ height: '80vh' }}>
            <div className='col-lg-12 col-md-12 col-12'>
                <div className='d-flex flex-column justify-content-between border h-100 p-3' style={{ background: '#F5F5F5' }}>
                    <div className='row pb-3'>
                        <div className='row page-content pt-2'>
                            {viewFieldsArry?.length > 0 && viewFieldsArry?.map((result, index) => {
                                if (result?.type === 'Text') {
                                    return (
                                        <div className={`${result?.fieldSize === 'col-4' ? 'mt-3' : ''} ${result?.fieldSize}`} key={index}>
                                            <div>
                                                <div className='d-flex justify-content-between mt-1'>
                                                    <div className='font-14'>{result?.label}</div>
                                                </div>
                                            </div>
                                            <FormField
                                                name={'text'}
                                                value={fields?.[result?.fieldId] || ""}
                                                onChange={(e) => handleTextChange(e, result.fieldId)}
                                                data={{ label: '', placeholder: '', type: 'text' }} />
                                        </div>
                                    );
                                }
                                if (result?.type === 'Date') {
                                    return (
                                        <div className={`${result?.fieldSize === 'col-4' ? 'mt-3' : ''} ${result?.fieldSize}`} key={index}>
                                            <div>
                                                <div className='d-flex justify-content-between mt-1'>
                                                    <div className='font-14'>{result?.label}</div>
                                                </div>
                                            </div>
                                            <div className="mt-3 col-12 border p-1 rounded bg-body">
                                                {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DatePicker
                                                        inputFormat="MM/dd/yyyy"
                                                        value={moment(fields?.[result?.fieldId] || null).format('MM/dd/yyyy')}
                                                        onChange={(date) => handleDateChange(date, result?.fieldId)}
                                                        className='col-12 border-none'
                                                        renderInput={(params) => <TextField variant="standard" {...params} />}
                                                    />
                                                </LocalizationProvider> */}
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DatePicker
                                                        inputFormat="MM/dd/yyyy"
                                                        value={fields?.[result?.fieldId] ? new Date(fields?.[result?.fieldId]) : null}
                                                        onChange={(date) => handleDateChange(date, result?.fieldId)} // Ensure `date` is handled as a Date object
                                                        className='col-12 border-none'
                                                        renderInput={(params) => <TextField variant="standard" {...params} />}
                                                    />
                                                </LocalizationProvider>

                                            </div>
                                        </div>
                                    );
                                }
                                if (result?.type === 'Multiple Choice') {
                                    return (
                                        <div className={`${result?.fieldSize === 'col-4' ? 'mt-3' : ''} ${result?.fieldSize}`} key={index}>
                                            <div>
                                                <div className='d-flex justify-content-between mt-1'>
                                                    <div className='font-14'>{result?.label}</div>
                                                </div>
                                            </div>
                                            <FormControl>
                                                <RadioGroup
                                                    value={fields[result.fieldId] || ""}
                                                    onChange={(e) => handleRadioChange(e, result.fieldId)}>
                                                    {result?.options?.map((val, index) => (
                                                        <FormControlLabel key={index} value={val.optionId} control={<Radio />} label={val.name} />
                                                    ))}
                                                </RadioGroup>
                                            </FormControl>
                                        </div>
                                    );
                                }
                                // if (result?.type === 'CheckBox') {
                                //     return (
                                //         <div className={`${result?.fieldSize === 'col-4' ? 'mt-3' : ''} ${result?.fieldSize}`} key={index}>
                                //             <div>
                                //                 <div className='d-flex justify-content-between mt-1'>
                                //                     <div className='font-14'>{result?.label}</div>
                                //                 </div>
                                //             </div>
                                //             {/* <FormGroup row>
                                //                 {result?.options?.map((val, index) => (
                                //                     <FormControlLabel key={index} control={
                                //                         <Checkbox
                                //                             checked={(fields?.[result?.fieldId] || [])?.includes(val?.optionId)}
                                //                             onChange={(e) => handleCheckboxChange(e, val, result.fieldId)}
                                //                         />} label={val.name} />
                                //                 ))}
                                //             </FormGroup> */}
                                //             <FormGroup row>
                                //                 {result?.options?.map((val, index) => (
                                //                     <FormControlLabel
                                //                         key={index}
                                //                         control={
                                //                             <Checkbox
                                //                                 checked={(Array.isArray(fields?.[result?.fieldId]) ? fields?.[result?.fieldId] : []).includes(val?.optionId)}
                                //                                 onChange={(e) => handleCheckboxChange(e, val, result.fieldId)}
                                //                             />
                                //                         }
                                //                         label={val.name}
                                //                     />
                                //                 ))}
                                //             </FormGroup>

                                //         </div>
                                //     );
                                // }
                                if (result?.type === 'CheckBox') {
                                    return (
                                        <div className={`${result?.fieldSize === 'col-4' ? 'mt-3' : ''} ${result?.fieldSize}`} key={index}>
                                            <div>
                                                <div className='d-flex justify-content-between mt-1'>
                                                    <div className='font-14'>{result?.label}</div>
                                                </div>
                                            </div>
                                            <FormGroup row>
                                                {result?.options?.map((val, index) => (
                                                    <FormControlLabel
                                                        key={index}
                                                        control={
                                                            <Checkbox
                                                                checked={Array.isArray(fields?.[result?.fieldId]) ? fields?.[result?.fieldId].includes(val?.optionId) : false}
                                                                onChange={(e) => handleCheckboxChange(e, val, result.fieldId)}
                                                            />
                                                        }
                                                        label={val.name}
                                                    />
                                                ))}
                                            </FormGroup>
                                        </div>
                                    );
                                }
                                
                                if (result?.type === 'Dropdown') {
                                    return (
                                        <div className={`${result?.fieldSize === 'col-4' ? 'mt-3' : ''} ${result?.fieldSize}`} key={index}>
                                            <div>
                                                <div className='d-flex justify-content-between mt-1'>
                                                    <div className='font-14'>{result?.label}</div>
                                                </div>
                                            </div>
                                            <div className="col-12 mt-3 border rounded bg-body">
                                                <Select
                                                    value={fields[result.fieldId] || ""}
                                                    onChange={(e) => handleInputChange(e, result.fieldId)}
                                                    variant="outlined"
                                                    className='w-100 font-14'
                                                    size='small'>
                                                    {result?.options?.map((val, index) => (
                                                        <MenuItem key={index} value={val.optionId} className='font-14'>{val.name}</MenuItem>
                                                    ))}
                                                </Select>
                                            </div>
                                        </div>
                                    );
                                }
                                if (result?.type === 'Title') {
                                    return (
                                        <div className={`${result?.fieldSize === 'col-4' ? 'mt-3' : ''} ${result?.fieldSize}`} key={index}>
                                            <div>
                                                <div className='d-flex justify-content-between mt-1'>
                                                    <div className='font-14'>{result?.label}</div>
                                                </div>
                                            </div>
                                            <FormField
                                                name={'title'}
                                                value={fields[result.fieldId] || ""}
                                                onChange={(e) => handleTextChange(e, result.fieldId)}
                                                data={{ label: '', placeholder: '', type: 'text' }} />
                                        </div>
                                    );
                                }
                                return null
                            })}
                        </div>
                    </div>
                    <div className="d-flex justify-content-center">
                          <button className="btn btn-secondary px-5 mx-2" onClick={()=>setViewFormModal(false)}>Cancel</button>
                        <button className="theme-btn bgDarkBlue px-5 mx-2" onClick={handleSubmit}>Submit</button>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default ViewForm
